// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","ad-site-wrapper":"ad-site-wrapper","footer":"z4E3IQpl","mobile":"mobile"};